// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-mini .el-select[data-v-2d758f6f]{\n    width:100%;\n}\n.stext[data-v-2d758f6f]{\n    line-height: 33px;\n    width: 20%;\n}\n.elselect[data-v-2d758f6f]{\n    width: 80%;\n}\n", ""]);
// Exports
module.exports = exports;
